import { getMemberInfo } from "@/hooks/useMembers";
import MHeader from "@/components/ui/organisms/MHeader";
import MSpacer from "@/components/ui/atoms/MSpacer";
import { useEffect } from "react";
import { formatDocumentDateShort } from "@/utils/date-utils";
import styles from "./PurchaseHistory.module.css";
import { IconCreditCard, IconCreditCardOff } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { usePurchaseHistory } from "@/hooks/useSubscription";

const PurchaseHistory = () => {
  const { t } = useTranslation();
  const memberInfo = getMemberInfo();
  const { history, loading, fetchPurchaseHistory } = usePurchaseHistory();

  useEffect(() => {
    fetchPurchaseHistory(1, 50);
  }, [fetchPurchaseHistory]);

  if (loading) {
    return null;
  }

  return (
    <div className="profile-page-root">
      <MHeader
        title={t("subscription.purchaseHistory.title")}
        module="subscription"
        memberInfo={memberInfo}
        description={t("subscription.purchaseHistory.description")}
        showGradient
      />

      <MSpacer mt={24} />

      <div>
        {!history || history.data.length === 0 ? (
          <div className={styles.emptyStateCard}>
            <IconCreditCardOff
              className={styles.emptyStateIcon}
              size={64}
              color="#AD95D1"
              stroke={1.5}
            />
            <div className={styles.emptyStateText}>
              {t("subscription.purchaseHistory.emptyMessage")}
            </div>
          </div>
        ) : (
          <div className={styles.historyContainer}>
            {history.data.map((item) => (
              <div key={item.id} className={styles.historyCard}>
                <div className={styles.historyCardContent}>
                  <div className={styles.iconWrapper}>
                    <IconCreditCard size={24} color="#7046AE" />
                  </div>
                  <div className={styles.historyInfo}>
                    <div className={styles.historyDate}>
                      {formatDocumentDateShort(item.endDate, true)}
                    </div>
                    <div className={styles.historyPlanName}>
                      {item.plan?.name || "Subscription"}
                    </div>
                  </div>
                  <div className={styles.historyPrice}>
                    ₹ {(item.plan as any)?.amount || 0}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseHistory;
